import moment from 'moment-timezone'

export const formatDateWithTimezone = (date: string, format: string, timezone: string): string => {
  if (!date) return '-'
  return moment(date)
    .tz(timezone || moment.tz.guess())
    .format(format)
}

export const convertToMiliseconds = (seconds: number): number => {
  return seconds * 1000
}
